import { useEffect } from 'react';
import { useAuthStore } from '@/stores/useAuthStore';
import { useAppStore } from '@/stores/useAppStore';
import { performanceService } from '@/services/performanceService';
import { getTodayISO } from '@/lib/constants';

/**
 * Hook to automatically calculate moving averages for habits
 * Runs daily to keep trend data updated
 */
export function useMovingAverages() {
  const { user } = useAuthStore();
  const { habits } = useAppStore();

  useEffect(() => {
    if (!user || !habits || habits.length === 0) return;

    const calculateAverages = async () => {
      const today = getTodayISO();
      const activeHabits = habits.filter((h) => h.active && h.userId === user.id);

      try {
        // Calculate moving averages for each active habit
        for (const habit of activeHabits) {
          await performanceService.calculateMovingAverage(habit.id, today);
        }

        console.log('Moving averages calculated for', activeHabits.length, 'habits');
      } catch (error) {
        console.error('Error calculating moving averages:', error);
      }
    };

    // Calculate on mount
    calculateAverages();

    // Re-calculate daily at midnight
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    const msUntilMidnight = tomorrow.getTime() - now.getTime();

    const timeout = setTimeout(() => {
      calculateAverages();
      // Set up daily interval
      const interval = setInterval(calculateAverages, 24 * 60 * 60 * 1000);
      return () => clearInterval(interval);
    }, msUntilMidnight);

    return () => clearTimeout(timeout);
  }, [user, habits]);
}
